exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box[data-v-3af3885a] {\n  margin-top: 0.53rem;\n}\n.box ul[data-v-3af3885a] {\n  width: 80%;\n  margin: auto;\n  margin-top: 0.53rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.box ul img[data-v-3af3885a] {\n  width: 1.066rem;\n  display: block;\n}\n.box ul span[data-v-3af3885a] {\n  display: block;\n  text-align: center;\n  margin-top: 0.1rem;\n  font-size: 0.266rem;\n}\n.p1[data-v-3af3885a] {\n  font-size: 0.32rem;\n  color: #999;\n  text-align: center;\n}\n", ""]);

// exports
